var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-2"},[_c('v-container',{attrs:{"fluid":""}},[[_c('v-subheader',{staticClass:"pl-0"},[_c('p',{staticClass:"font-weight-bold text-uppercase black--text text-h6 mb-0"},[_vm._v(" "+_vm._s(_vm.subHeaderTitle)+" ")]),_c('div',[_c('small')])]),_c('v-divider',{staticClass:"mt-0 pt-0"})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }